export default __webpack_public_path__ + "f5227eaa010e92c9275f37ea126798bd.jpg";